import { render, staticRenderFns } from "./HerramientasModal.vue?vue&type=template&id=1b4eca1a&scoped=true"
import script from "./HerramientasModal.vue?vue&type=script&lang=js"
export * from "./HerramientasModal.vue?vue&type=script&lang=js"
import style0 from "./HerramientasModal.vue?vue&type=style&index=0&id=1b4eca1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4eca1a",
  null
  
)

export default component.exports